import { withPrefix } from '../utils/bem';

export const cn = withPrefix('UiKit');
